import { useShallow } from "zustand/shallow";

import type { ActivityId, PlayerId } from "@/types/branded";

import { useStore } from "./store";

// ── Record selectors (raw dictionaries) ────────────────────────

export const usePlayers = () => useStore((s) => s.players);
export const useActivities = () => useStore((s) => s.activities);
export const useMatches = () => useStore((s) => s.matches);
export const useResults = () => useStore((s) => s.results);
export const useLastStatusEvent = () => useStore((s) => s.lastStatusEvent);
export const useStatusHistory = () => useStore((s) => s.statusHistory);

// ── Array selectors (Object.values with shallow equality) ──────

export const usePlayerList = () => useStore(useShallow((s) => Object.values(s.players)));
export const useActivityList = () => useStore(useShallow((s) => Object.values(s.activities)));
export const useBetList = () => useStore(useShallow((s) => Object.values(s.bets)));

// ── Single-item selectors ──────────────────────────────────────

export const usePlayer = (id: PlayerId | undefined) =>
  useStore((s) => (id ? s.players[id] : undefined));
export const useActivity = (id: ActivityId | undefined) =>
  useStore((s) => (id ? s.activities[id] : undefined));

// ── Derived selectors ──────────────────────────────────────────

export const useMatchCount = () => useStore((s) => Object.keys(s.matches).length);

/** Sorted player list by total points (descending) — useful for leaderboards */
export const useLeaderboard = () =>
  useStore(
    useShallow((s) => Object.values(s.players).sort((a, b) => b.totalPoints - a.totalPoints)),
  );
